<template>
  <div class="memberInfo">
    <div v-html="datasHtml"></div>
  </div>
</template>

<script>
import { getUserLevelDetails } from "@api/lcapi";
export default {
  name: "MemberInfo",
  components: {},
  data() {
    return {
      level_id: "", // 会员等级ID
      datasHtml: ""
    };
  },
  mounted() {
    this.level_id = this.$route.query.id;
    this.getUserLevelDetails();
  },
  methods: {
    getUserLevelDetails() {
      getUserLevelDetails({ nid: this.level_id }).then(res => {
        res.data.content = res.data.content.replace(
          /\<img/gi,
          '<img style="max-width:100%;height:auto;display:block;"'
        );

        this.datasHtml = res.data.content;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.memberInfo {
  padding: 0.24rem;
  img {
    display: block;
    width: 100%;
  }
}
</style>
